import React, { FC, useEffect, useState, useMemo, useRef } from 'react'
import qs from 'querystring'
import { useDispatch, useSelector } from 'react-redux'
import {
    PageHeader, List, Col, Row, Descriptions, Progress,
    Button, Space, Image, Select,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// import { push } from 'connected-react-router'
import { authsignin, signinSuccess, signupFail } from '@/store/actions/auth.action'
import type { IAppState } from '@/store/reducers'
import { getWorkgroup, setProjectInfoPagination } from '@/store/actions/tableEdit.action'
import { exportExcel, techTotal } from '@/services/table.service'
import chartsImg from '@/assets/images/charts.png'
import chartsImg2 from '@/assets/images/charts2.png'
import chartsImg3 from '@/assets/images/charts3.jpg'
import chartsImg4 from '@/assets/images/charts4.jpg'
import { notifyMsg } from '@/pages/login'
import { getErrorStr } from '@/store/sagas/table.saga'
import { downloadFile } from '@/utils/util'
import Rag from '@/pages/rag'
import Nav from '@/components/nav'

export interface IWorkgroupRouteParam {
    text: string
    url: string
    data?: number
}

export const getTechTotal = async (): Promise<{ max: number, yearList: any[] }> => {
    const res = await techTotal()
    res.sort((a, b) => a.year - b.year)
    const curYear = new Date().getFullYear() - 1
    const _yearList = []
    for (let i = 0; i < 6; i++) {
        const findIndex = res.findIndex(item => item.year === curYear + i)
        if (findIndex === -1) {
            _yearList.push({
                year: curYear + i,
                total: 0
            })
        } else {
            _yearList.push(res[findIndex])
        }
    }
    const _maxObj = res.reduce((prev, item) => prev.total > item.total ? prev : item, 0)
    return {
        max: _maxObj.total,
        yearList: _yearList
    }
}

const Index: FC = () => {
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const { Option } = Select
    const signinState = useSelector((state: IAppState) => state.auth.signin)
    const signoutState = useSelector((state: IAppState) => state.auth.signup)
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const [showList, setShowList] = useState<IWorkgroupRouteParam[]>([
        // {
        //     text: `${t('charts')}${i18n.language !== 'zh' ? ' ' : ''}${t('list')}`,
        //     url: '/charts'
        // },
        // {
        //     text: t('manage') + (i18n.language !== 'zh' ? ' ' : '') + t('technology roadmap'),
        //     url: '/keyRoadMap'
        // },
    ])
    const [yearList, setYearList] = useState<any[]>([])
    const [max, setMax] = useState<number>(0)


    const iconDataLs = useMemo<any[]>(() =>
        [{
            title: t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalReview')
                + (i18n.language !== 'zh' ? ' ' : '') + t('apply'),
            url: '/techReviewAdd?type=1',
            disabled: !(authInfo && Reflect.has(authInfo, 'techReviewAdd'))
        }, {
            title: t('technicalReviewProcess'),
            url: '/techReviewProgress',
            disabled: !(authInfo && Reflect.has(authInfo, 'techReviewProgress'))
        }, {
            title: t('process') + (i18n.language !== 'zh' ? ' ' : '') + t('assistant'),
            url: '/assistant',
        }, {
            title: t('TMTTechBack'),
            url: '/voteReport',
            disabled: false
        }, {
            title: t('Globle Search'),
            url: '/projectInfoSearch',
            disabled: !(authInfo && Reflect.has(authInfo, 'globleSearch'))
        }, {
            title: t('techTree'),
            url: '/techTree',
            disabled: !(authInfo && Reflect.has(authInfo, 'techTree'))
        }, {
            title: t('contribution degree'),
            url: '/contribution',
            disabled: !(authInfo && Reflect.has(authInfo, 'contributionDegree'))
        }, {
            title: t('indexTitle'),
            url: '/bigScreen2',
            disabled: !(authInfo && Reflect.has(authInfo, 'viewBigScreen'))
        }, {
            title: t('activityTitle'),
            url: '/charts',
            disabled: !(authInfo && Reflect.has(authInfo, 'viewCharts'))
        },
        //  {
        //     title: t('proposal board'), // 
        //     url: '/proposalBoard', // 新数据看板路径
        //     disabled: !(authInfo && Reflect.has(authInfo, 'contributionDegree')) // 与贡献度为同一权限点，后续可调整
        // }
        ]
    , [authInfo])
    const [autoPopRag, setAutoPopRag] = useState(false)
    const openAssi = useRef<any>()

    const goBigScreen = (num?: any) => {
        if (num !== 2) {
            history.replace('/bigScreen')
        } else {
            history.replace('/bigScreen2')
        }
    }
    const goPage = (url: string) => {
        history.push(`/${url}`)
    }
    const goChangeApplyList = () => {
        history.push('/projectInfoChangeApplyList')
    }
    const goTechReviewProcess = () => {
        history.push('/techReviewProgress')
    }
    const goViewLogListAll = () => {
        history.push('/viewLogList')
    }
    const goVote = () => {
        history.push('/voteReport')
    }
    const goContribution = () => {
        history.push('/contribution')
    }
    const goAddTechReview = () => {
        history.push('/techReviewAdd?type=1')
    }
    const getTechTotalFn = async () => {
        try {
            const techTotalData = await getTechTotal()
            setMax(techTotalData.max)
            setYearList(techTotalData.yearList)
        } catch (error: any) {
            const str = getErrorStr(error)
            console.log('getTechTotalFn: ', 'signupFail')
            dispatch(signupFail(str))
        }
    }

    const openQuestion = (params: any) => {
        openAssi.current = params
    }

    useEffect(() => {
        const { search } = history.location
        // visual 跳转带 token 过来时自动登录
        if (search) {
            const tokenObj = qs.parse(search.slice(1)) as { token: string; redirect?: string }
            if (tokenObj.token) {
                dispatch(authsignin(tokenObj.token))
            }
            // 如果有参数 redirect=assistant，则自动弹出提案助手
            if (tokenObj?.redirect === 'assistant') {
                setAutoPopRag(true)
            }
        }
        // 获取 workgroupList
        dispatch(getWorkgroup())
        // get techTotal
        getTechTotalFn()
    }, [])
    useEffect(() => {
        const list: any[] = []
        const workgroup: IWorkgroupRouteParam[] = workgroupList.map(item => ({
            text: item.groupName,
            url: '/projectInfo',
            data: item.id
        }))
        Array.prototype.push.apply(list, workgroup)
        setShowList(list)
    }, [workgroupList])
    useEffect(() => {
        // 自动登录时错误
        if ((signinState.loaded && !signinState.success) ||
            // 退出登录
            (signoutState.loaded && signoutState.success)
        ) {
            history.replace('/login')
        }
        // 登录成功
        if (signinState.loaded && signinState.success && signinState.message) {
            notifyMsg(signinState.message)
            dispatch(signinSuccess(''))
        }
    }, [signinState, signoutState])
    return (
        <>
            <Nav dispatch={dispatch} />
            {!1 && <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                <PageHeader className='chart_title'
                    onBack={() => null}
                    title={authInfo && Reflect.has(authInfo, 'viewBigScreen')
                        ? <span style={{ cursor: 'pointer' }} onClick={goBigScreen}>{t('indexTitle')}</span>
                        : <span>{t('indexTitle')}</span>
                    }
                    extra={<Space>
                        <Select style={{ width: 180 }} placeholder='请选择' value='indexPage'
                            onChange={(e: string) => {
                                const exportFn = async () => {
                                    const res = await exportExcel({})
                                    downloadFile(res, 'All' + '.ProjectInfo.' + res.suffix)
                                }
                                switch (e) {
                                    case 'toolIndex':
                                        window.open('http://devops.desaysv.com/#/tools/tool', '_blank')
                                        break
                                    case 'indexPage':
                                        break
                                    case 'exportAll':
                                        exportFn()
                                        break
                                    default:
                                        goPage(e)
                                }
                            }}
                        >
                            <Option value='indexPage'>{t('indexPage')}</Option>
                            <Option value='techTree'>{t('techTree')}</Option>
                            {authInfo && (<>
                                {Reflect.has(authInfo, 'manageWorkgroup') &&
                                    <Option value='workgroupAdd'>{t('manage workgroup')}</Option>}
                                {/* {Reflect.has(authInfo, 'manageProcess') && 
                                <Option value='progress'>{t('process') + (i18n.language !== 'zh' ? ' ' : '') + t('apply')}</Option>} */}
                                {/* {Reflect.has(authInfo, 'changeApplyList') &&
                                <Option value='projectInfoChangeApplyList'>{t('approvalList')}</Option>} */}
                                {/* {Reflect.has(authInfo, 'viewLogListAll') &&
                                <Option value='viewLogList'>{t('View Log List All')}</Option>} */}
                                {Reflect.has(authInfo, 'globleSearch') &&
                                    <Option value='projectInfoSearch'>{t('Globle Search')}</Option>}
                                {Reflect.has(authInfo, 'exportAll') &&
                                    <Option value='exportAll'>{t('exportAll')}</Option>}
                                {Reflect.has(authInfo, 'techChangeList') &&
                                    <Option value='techChangeList'>{t('Tech Change Status') + (i18n.language !== 'zh' ? ' ' : '') + t('list')}</Option>}
                                {Reflect.has(authInfo, 'organStructure') &&
                                    <Option value='organList'>{t('organStructure')}</Option>}
                                {/* {authInfo && Reflect.has(authInfo, 'techRelative') &&
                                <Option value='techRelative'>{t('Tech Relative')}</Option>} */}
                                {Reflect.has(authInfo, 'techRelative') &&
                                    <Option value='techRelativeAnalysis'>{t('Tech Relative')}</Option>}
                                {Reflect.has(authInfo, 'technicalShelf') &&
                                    <Option value='technicalShelf'>{t('technicalShelf')}</Option>}
                                {Reflect.has(authInfo, 'buAndCtListMana') && <Option value='buAndCtListMana'>{t('buAndCtList') + (i18n.language !== 'zh' ? ' ' : '') + t('manage')}</Option>}
                                {Reflect.has(authInfo, 'prodListMana') && <Option value='prodListMana'>{t('product') + (i18n.language !== 'zh' ? ' ' : '')
                                     + (i18n.language !== 'zh' ? ' ' : '') + t('manage')}</Option>}
                            </>)}
                            <Option value='toolIndex'>{t('toolManagement')}</Option>
                        </Select>
                        {/* {authInfo && Reflect.has(authInfo, 'manageProcess') && 
                            <Button type='primary' onClick={goManageProcess}>{t('addReview')}
                            </Button>
                        } */}
                        {authInfo && (<>
                            {(Reflect.has(authInfo, 'techReviewAdd')) && <Button icon={<PlusOutlined />}
                                type='primary'
                                onClick={goAddTechReview}
                            >{t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalReview')
                                + (i18n.language !== 'zh' ? ' ' : '') + t('apply')}</Button>}
                            {Reflect.has(authInfo, 'techReviewProgress') &&
                                <Button type='primary' onClick={goTechReviewProcess}>{t('technicalReviewProcess')}
                                </Button>}
                            {Reflect.has(authInfo, 'changeApplyList') &&
                                <Button type='primary' onClick={goChangeApplyList}>{t('approvalList')}
                                </Button>}
                            {Reflect.has(authInfo, 'viewLogListAll') &&
                                <Button type='primary' onClick={goViewLogListAll}>{t('View Log List All')}
                                </Button>}
                            <Button type='primary' onClick={goVote}>
                                {t('TMTTechBack')}
                            </Button>
                            {/* <Button type='primary' onClick={goContribution}>
                                {t('contribution degree statistics')}
                            </Button> */}
                        </>)}
                    </Space>}
                />
            </Space>}
            <div className='index_ls' style={{ marginTop: 28, marginBottom: 28, minHeight: 70 }}>
                <List dataSource={iconDataLs}
                    className='icon_list'
                    grid={{
                        column: 4,
                        gutter: 16,
                        xs: 4,
                        sm: 5,
                        md: 7,
                        lg: 9,
                        xl: 9,
                        xxl: 9,
                    }}
                    renderItem={(item, index) => (
                        <List.Item
                            key={item.title}
                            onClick={() => {
                                if (item.url === '/assistant') {
                                    const calback = openAssi.current
                                    calback && calback()
                                    return
                                }
                                if (!item.disabled) {
                                    history.push(item.url)
                                }
                            }}
                        >
                            <List.Item.Meta className={`icon icon_${index + 1} ${item.disabled ? 'disabled' : ''}`}
                                avatar={<div>&nbsp;</div>}
                                title={<a href={item.href}>{item.title}</a>}
                            />
                        </List.Item>
                    )}
                ></List>
            </div>
            <Row justify='space-between'>
                <Col span={14}>
                    <Space direction='vertical'>
                        <div className='index_ls'>
                            <List
                                bordered
                                dataSource={showList}
                                className='icon_list2'
                                grid={{
                                    gutter: 5,
                                    xs: 2,
                                    sm: 3,
                                    md: 4,
                                    lg: 4,
                                    xl: 6,
                                    xxl: 8,
                                }}
                                style={{ padding: '0 5%' }}
                                renderItem={(item, index) => (
                                    // 数据统计、查看技术路线图需要判断权限
                                    <List.Item
                                        className={
                                            ((item.url.includes('charts')) && (authInfo && Reflect.has(authInfo, 'viewStatistics'))) ||
                                                ((item.url.includes('keyRoadMap')) && (authInfo && Reflect.has(authInfo, 'viewEnterRoadMap'))) ||
                                                (item.url.includes('projectInfo') && (authInfo && Reflect.has(authInfo, 'viewTechList')))
                                                ? 'hand' : ''
                                        }
                                        onClick={() => {
                                            let str = item.url
                                            if (((str.includes('charts')) && (authInfo && Reflect.has(authInfo, 'viewStatistics'))) ||
                                                ((str.includes('keyRoadMap')) && (authInfo && Reflect.has(authInfo, 'viewEnterRoadMap'))) ||
                                                (str.includes('projectInfo') && (authInfo && Reflect.has(authInfo, 'viewTechList')))
                                            ) {
                                                if ('data' in item) {
                                                    str += '?workGroupId=' + item.data
                                                }
                                                dispatch(setProjectInfoPagination({
                                                    pageIndex: 1
                                                }))
                                                history.push(str)
                                            }
                                        }}
                                    // actions={[
                                    //     <Text 
                                    //         className={
                                    //             ((item.url.includes('charts')) && (authInfo && Reflect.has(authInfo, 'viewStatistics'))) ||
                                    //             ((item.url.includes('keyRoadMap')) && (authInfo && Reflect.has(authInfo, 'viewEnterRoadMap'))) ||
                                    //             (item.url.includes('projectInfo') && (authInfo && Reflect.has(authInfo, 'viewTechList')))
                                    //                 ? 'txt_blue' : 'hide'
                                    //         }
                                    //         title={t('view')}
                                    //     ><FileSearchOutlined style={{ fontSize: 16 }} /></Text>
                                    // ]}
                                    >
                                        {/* <span>
                                            {index > 1
                                                ? <Text mark>[WG{index - 1}]</Text>
                                                : (index == 0 ? <LineChartOutlined /> : <BlockOutlined />)
                                            } {item.text}
                                        </span> */}
                                        <List.Item.Meta className={`icon icon_${index + 1}`}
                                            avatar={<div>&nbsp;</div>}
                                            title={<a>{item.text}</a>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className='index_ls'
                            style={{ position: 'relative', cursor: 'pointer' }}
                            onClick={goContribution}
                        >
                            <span style={{
                                position: 'absolute', left: 8, top: 5, zIndex: 2,
                                fontWeight: 'bold', background: '#fff'
                            }}
                            >{t('contribution degree statistics')}</span>
                            <Image src={chartsImg3} width='100%' preview={false} rootClassName='img_blur' />
                        </div>

                    </Space>
                </Col>
                <Col span={10}>
                    <Space direction='vertical'
                        style={{ width: '100%' }}
                    >
                        <Descriptions layout='vertical' bordered className='index_ls'
                            style={{ marginLeft: 0 }}
                        >
                            <Descriptions.Item label={t('year')}>
                                <List
                                    dataSource={yearList}
                                    renderItem={item => (
                                        <List.Item>
                                            {item.year}
                                        </List.Item>
                                    )}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Tech Total')}>
                                <List
                                    dataSource={yearList}
                                    renderItem={item => (
                                        <List.Item>
                                            <Progress percent={Math.round(item.total / max * 100)} size='default' status='normal'
                                                strokeColor={{
                                                    '0%': '#108ee9',
                                                    '100%': '#87d068',
                                                }}
                                                format={() => item.total}
                                            />
                                        </List.Item>
                                    )}
                                />
                            </Descriptions.Item>
                        </Descriptions>
                        {authInfo && Reflect.has(authInfo, 'viewBigScreen') && <div className='index_ls'
                            style={{ marginLeft: 0, cursor: 'pointer' }}
                            onClick={() => {
                                goBigScreen(2)
                            }}
                        >
                            <Image src={chartsImg2} width='100%' preview={false} rootClassName='img_blur' />
                        </div>}
                        {authInfo && Reflect.has(authInfo, 'viewBigScreen') && <div className='index_ls'
                            style={{ marginLeft: 0, cursor: 'pointer' }}
                            onClick={() => {
                                goBigScreen()
                            }}
                        >
                            <Image src={chartsImg} preview={false} rootClassName='img_blur' />
                        </div>}
                        {/* 新增技术活跃度统计模块 */}
                        <div className='index_ls'
                            style={{ marginLeft: 0, cursor: 'pointer',position:'relative' }}
                            onClick={() => {
                                history.push('/proposalBoard')
                            }}
                        >
                            <span style={{
                                position: 'absolute', left: 8, top: 5, zIndex: 2,
                                fontWeight: 'bold', background: '#fff'
                            }}
                            >{t('proposal board')}</span>
                            <Image src={chartsImg4} width='100%' preview={false} rootClassName='img_blur' />
                        </div>
                    </Space>

                </Col>
            </Row>

            <Rag autoPopRag={autoPopRag} openQuestion={openQuestion} />
        </>
    )
}

export default Index
